import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { SUPPORT_EMAIL } from '../../shared/links';
import styles from './Footer.css';

const cx = classnames.bind(styles);

function Footer({className}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <footer className={classes}>
            <div className={styles.wrapper}>
                <address className={styles.address}>© 2021—{new Date().getFullYear()} Jorefil Limited. Georgiou Christoforou 8, 1st floor, Strovolos, 2012, Nicosia, Cyprus. All rights reserved;</address>
                <p className={styles.information}>Futureproof is not an insurance or legal company. We provide tools and advisory services to help you secure your life.</p>
                <div className={styles.links}>
                    <CustomLink
                        to={`mailto:${SUPPORT_EMAIL}`}
                        target='_blank'
                        className={styles.link}
                    >
                        {SUPPORT_EMAIL}
                    </CustomLink>
                    <CustomLink
                        to='/terms-and-conditions.html'
                        target='_blank'
                        className={styles.link}
                    >
                        Terms and conditions
                    </CustomLink>
                    <CustomLink
                        to='/privacy-policy.html'
                        target='_blank'
                        className={styles.link}
                    >
                        Privacy policy
                    </CustomLink>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    className: PropTypes.string
};

Footer.defaultProps = {
    className: ''
};

export {
    Footer
};
